import requester from '@/services/requester'
import env from '@/.env.js'

const BACKEND_API_V1_URL = env.endpoint_backend

export default {
    retrieve (parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/users`, parameters)
    },

    retrieveSelf (parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/users/getSelf`, parameters)
    },

    update (parameters) {
        return requester.put(`${BACKEND_API_V1_URL}/users`, parameters)
    },

    updateCart (parameters) {
        return requester.put(`${BACKEND_API_V1_URL}/users/update-cart`, parameters)
    }
}